import React from 'react'

export default function CourseAvailability(props) {
  return (
    <span>{props.availability}</span>
  )
}
